/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface IdNameResultOflong
 */
export interface IdNameResultOflong {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof IdNameResultOflong
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof IdNameResultOflong
     */
    name: string;
}

/**
 * Check if a given object implements the IdNameResultOflong interface.
 */
export function instanceOfIdNameResultOflong(value: object): value is IdNameResultOflong {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IdNameResultOflongFromJSON(json: any): IdNameResultOflong {
    return IdNameResultOflongFromJSONTyped(json, false);
}

export function IdNameResultOflongFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdNameResultOflong {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'name': json['name'],
    };
}

export function IdNameResultOflongToJSON(json: any): IdNameResultOflong {
    return IdNameResultOflongToJSONTyped(json, false);
}

export function IdNameResultOflongToJSONTyped(value?: IdNameResultOflong | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'name': value['name'],
    };
}

